import React from "react";
import "./BazeleConta.css";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faChevronRight,
  faBookOpen,
  faChartLine,
  faCheck,
  faClipboardCheck,
  faLayerGroup,
  faLightbulb,
  faArrowRight,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";

import bazeleconta from "../../imagesHome/bazeleconta.png";

const modules = [
  {
    number: "01",
    title: "Introducere in contabilitate",
    description:
      "Descopera rolul contabilitatii si modul in care aceasta te ajuta sa intelegi activitatea unei firme.",
  },
  {
    number: "02",
    title: "Patrimoniul intreprinderii",
    description:
      "Intelege structura patrimoniului si elementele care definesc situatia economica a unei firme.",
  },
  {
    number: "03",
    title: "Contul si dubla inregistrare",
    description:
      "Invata cum functioneaza conturile si cum se aplica principiul dublei inregistrari.",
  },
  {
    number: "04",
    title: "Activele",
    description:
      "Studiaza activele firmei, clasificarea lor si rolul pe care il au in activitatea economica.",
  },
  {
    number: "05",
    title: "Datoriile",
    description:
      "Intelege ce reprezinta datoriile unei firme si cum influenteaza acestea structura patrimoniului.",
  },
  {
    number: "06",
    title: "Capitalurile proprii",
    description:
      "Descopera ce reprezinta capitalurile proprii si cum apar acestea in structura unei firme.",
  },
  {
    number: "07",
    title: "Veniturile si cheltuielile",
    description:
      "Intelege legatura dintre venituri, cheltuieli si formarea rezultatului exercitiului.",
  },
  {
    number: "08",
    title: "Evaluarea elementelor patrimoniale",
    description:
      "Parcurge regulile de baza privind evaluarea si reflectarea elementelor patrimoniale.",
  },
];

const BazeleConta = () => {
  return (
    <main className="bazele-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="bazele-hero">
        <div className="bazele-container">

          <div className="bazele-breadcrumb">
            <Link to="/cursuri-prezentare">
              Cursuri
            </Link>

            <FontAwesomeIcon icon={faChevronRight} />

            <span>Bazele contabilitatii</span>
          </div>

          <div className="bazele-hero-grid">

            {/* LEFT */}

            <div className="bazele-hero-content">

              <div className="bazele-course-icon">
                <img
                  src={bazeleconta}
                  alt="Bazele contabilitatii"
                />
              </div>

              <div className="bazele-eyebrow">
                <span className="bazele-eyebrow-dot" />
                CURS PENTRU INCEPATORI
              </div>

              <h1>
                Bazele
                <span> contabilitatii</span>
              </h1>

              <p className="bazele-hero-lead">
                Invata logica din spatele contabilitatii de la zero,
                intr-un curs construit pas cu pas pentru incepatori.
              </p>

              <p className="bazele-hero-description">
                Vei intelege activele, datoriile, capitalurile proprii,
                veniturile, cheltuielile si modul in care functioneaza
                conturile, folosind explicatii clare si exercitii practice.
              </p>

              <div className="bazele-hero-actions">

                <Link
                  to="/quiz-start"
                  className="bazele-button bazele-button-primary"
                >
                  Incepe cursul
                  <FontAwesomeIcon icon={faArrowRight} />
                </Link>

                <Link
                  to="/cursuri-prezentare"
                  className="bazele-button bazele-button-secondary"
                >
                  Vezi toate cursurile
                </Link>

              </div>

              <div className="bazele-no-experience">
                <FontAwesomeIcon icon={faCheck} />
                Nu ai nevoie de cunostinte anterioare
              </div>

            </div>


            {/* RIGHT */}

            <div className="bazele-course-preview">

              <div className="bazele-preview-top">

                <span className="bazele-preview-label">
                  BAZELE CONTABILITATII
                </span>

                <span className="bazele-preview-level">
                  Incepatori
                </span>

              </div>

              <div className="bazele-preview-image">
                <img
                  src={bazeleconta}
                  alt="Curs Bazele contabilitatii"
                />
              </div>

              <h2>
                Construieste o baza solida in contabilitate
              </h2>

              <p>
                De la primele concepte pana la logica inregistrarilor
                contabile.
              </p>

              <div className="bazele-preview-features">

                <div>
                  <span className="bazele-feature-icon">
                    <FontAwesomeIcon icon={faBookOpen} />
                  </span>

                  <span>
                    <strong>100+</strong>
                    Lectii interactive
                  </span>
                </div>

                <div>
                  <span className="bazele-feature-icon">
                    <FontAwesomeIcon icon={faClipboardCheck} />
                  </span>

                  <span>
                    <strong>100+</strong>
                    Quiz-uri
                  </span>
                </div>

                <div>
                  <span className="bazele-feature-icon">
                    <FontAwesomeIcon icon={faChartLine} />
                  </span>

                  <span>
                    <strong>100+</strong>
                    Aplicatii practice
                  </span>
                </div>

              </div>

              <Link
                to="/quiz-start"
                className="bazele-preview-button"
              >
                Incepe sa inveti
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>

            </div>

          </div>
        </div>
      </section>


      {/* =====================================================
          MODULE
      ===================================================== */}

      <section className="bazele-modules">
        <div className="bazele-container">

          <div className="bazele-section-heading">

            <span className="bazele-section-kicker">
              STRUCTURA CURSULUI
            </span>

            <h2>
              Ce vei invata in acest curs
            </h2>

            <p>
              Conceptele sunt introduse progresiv, astfel incat fiecare
              modul sa construiasca baza necesara pentru urmatorul.
            </p>

          </div>

          <div className="bazele-modules-grid">

            {modules.map((module) => (
              <article
                className="bazele-module-card"
                key={module.number}
              >

                <div className="bazele-module-number">
                  {module.number}
                </div>

                <div className="bazele-module-content">

                  <span>
                    MODUL {Number(module.number)}
                  </span>

                  <h3>
                    {module.title}
                  </h3>

                  <p>
                    {module.description}
                  </p>

                </div>

              </article>
            ))}

          </div>

        </div>
      </section>


      {/* =====================================================
          STATS
      ===================================================== */}

      <section className="bazele-stats">
        <div className="bazele-container">

          <div className="bazele-stats-heading">
            <span>CURS COMPLET</span>
            <h2>Tot ce ai nevoie pentru a invata de la zero</h2>
          </div>

          <div className="bazele-stats-grid">

            <div className="bazele-stat">
              <strong>100+</strong>
              <span>Lectii interactive</span>
            </div>

            <div className="bazele-stat">
              <strong>100+</strong>
              <span>Quiz-uri</span>
            </div>

            <div className="bazele-stat">
              <strong>100+</strong>
              <span>Aplicatii practice</span>
            </div>

            <div className="bazele-stat">
              <strong>8</strong>
              <span>Teste de modul</span>
            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          HOW IT WORKS
      ===================================================== */}

      <section className="bazele-learning">
        <div className="bazele-container">

          <div className="bazele-section-heading">

            <span className="bazele-section-kicker">
              METODA CONTALEARN
            </span>

            <h2>
              Nu doar citesti. Intelegi si aplici.
            </h2>

            <p>
              Fiecare etapa este gandita pentru a transforma conceptele
              contabile in cunostinte pe care le poti folosi.
            </p>

          </div>

          <div className="bazele-learning-grid">

            <article className="bazele-learning-card">

              <div className="bazele-learning-icon">
                <FontAwesomeIcon icon={faBookOpen} />
              </div>

              <span>01</span>

              <h3>Invata conceptul</h3>

              <p>
                Descopera fiecare notiune prin explicatii clare,
                structurate si exemple usor de urmarit.
              </p>

            </article>


            <article className="bazele-learning-card">

              <div className="bazele-learning-icon">
                <FontAwesomeIcon icon={faLightbulb} />
              </div>

              <span>02</span>

              <h3>Aplica imediat</h3>

              <p>
                Verifica ce ai inteles prin quiz-uri si aplicatii
                construite pe situatii contabile.
              </p>

            </article>


            <article className="bazele-learning-card">

              <div className="bazele-learning-icon">
                <FontAwesomeIcon icon={faChartLine} />
              </div>

              <span>03</span>

              <h3>Urmareste progresul</h3>

              <p>
                Vezi cat ai parcurs si continua invatarea exact
                de unde ai ramas.
              </p>

            </article>

          </div>

        </div>
      </section>


      {/* =====================================================
          FOR WHO
      ===================================================== */}

      <section className="bazele-for-who">
        <div className="bazele-container bazele-for-who-grid">

          <div className="bazele-for-who-left">

            <span className="bazele-section-kicker">
              PENTRU CINE ESTE CURSUL
            </span>

            <h2>
              Punctul tau de plecare in contabilitate
            </h2>

            <p>
              Cursul este construit pentru cei care vor sa inteleaga
              contabilitatea de la baza, fara explicatii complicate
              si fara presupunerea unor cunostinte anterioare.
            </p>

          </div>

          <div className="bazele-for-who-list">

            <div>
              <span>
                <FontAwesomeIcon icon={faCheck} />
              </span>

              <p>
                <strong>Incepatori</strong>
                Pentru cei care invata contabilitate pentru prima data.
              </p>
            </div>

            <div>
              <span>
                <FontAwesomeIcon icon={faCheck} />
              </span>

              <p>
                <strong>Studenti</strong>
                Pentru consolidarea conceptelor studiate la facultate.
              </p>
            </div>

            <div>
              <span>
                <FontAwesomeIcon icon={faCheck} />
              </span>

              <p>
                <strong>Antreprenori</strong>
                Pentru cei care vor sa inteleaga mai bine cifrele firmei.
              </p>
            </div>

            <div>
              <span>
                <FontAwesomeIcon icon={faCheck} />
              </span>

              <p>
                <strong>Viitori profesionisti</strong>
                Pentru construirea unei baze necesare studiului avansat.
              </p>
            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section className="bazele-final-cta">

        <div className="bazele-final-decoration bazele-final-decoration-one" />
        <div className="bazele-final-decoration bazele-final-decoration-two" />

        <div className="bazele-container bazele-final-content">

          <div className="bazele-final-icon">
            <FontAwesomeIcon icon={faGraduationCap} />
          </div>

          <span>
            INCEPE DE LA ZERO
          </span>

          <h2>
            Gata sa intelegi contabilitatea?
          </h2>

          <p>
            Incepe cu bazele si construieste-ti cunostintele pas cu pas,
            direct in ContaLearn.
          </p>

          <Link
            to="/quiz-start"
            className="bazele-final-button"
          >
            Incepe cursul gratuit
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>

        </div>

      </section>

    </main>
  );
};

export default BazeleConta;